import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Col, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import toast from 'react-hot-toast';
import ApiLinks from '../../Navlinks/ApiLinks';
import ImageUploadWithPreview from '../../Utilities/ImageUploadWithPreview';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ImagesGrid from '../../Utilities/ImagesGrid';


export default function AddImagesTab({ id }) {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (id) {
      loadData(id);
    }
  }, [id, user.compcode]);

  const loadData = async (propertyId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/${ApiLinks.PropertyImages_GetById}/${propertyId}/${user.compcode}`
      );
      if (response.data.status) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error('Error loading images:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!id || !user.compcode) {
      toast.error('Property ID or compcode missing');
      return;
    }
    if (!selectedFile) {
      toast.error('Please select an image');
      return;
    }
 
    setLoading(true);

    const formData = new FormData();
    formData.append('id', id || 0); // empty as per your API
    formData.append('propertyid', id);
    formData.append('images', selectedFile); // field name must be 'images'
    formData.append('compcode', user.compcode);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${ApiLinks.PropertyImages_Save}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        toast.success('Image uploaded successfully');
        setSelectedFile(null);
        loadData(id);
      } else 
      {
        toast.error(response.data.message || 'Upload failed');
      }
      
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      toast.error('Upload error');
     
    }
  };

  if (loading) return <LoaderOverlay />;

  return (
    <Box>
      <Grid gutter="md">
        {/* Upload Image */}
        <Col span={12} md={6}>
          <ImageUploadWithPreview
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            existingImagePath={null}
            setExistingImagePath={() => {}} // dummy function to prevent error
            label="Upload Property Image 16:9 "
            fullWidthPreview={true}
          />
        </Col>

        {/* Upload Button */}
        <Col span={12}>
          <Group position="left" mt="md">
            <Button onClick={handleSubmit}>Upload Image</Button>
            <Button variant="outline" onClick={() => navigate('/dashboard/floorplans')}>
              Cancel
            </Button>
          </Group>
        </Col>

        {/* Show Image Grid */}
        <Col span={12} mt="lg">
          <ImagesGrid data={data} setData={setData} compcode={user.compcode} />
        </Col>
      </Grid>
    </Box>
  );
}
